export default __webpack_public_path__ + "static/media/MaterialsExpensTemplate.4ed7ab41.xlsx";